import { render } from "./SAMWrap.vue?vue&type=template&id=1d61a023"
import script from "./SAMWrap.vue?vue&type=script&lang=js"
export * from "./SAMWrap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__